import c from "./consts";

export default {
    [c.COMPANIES]: [],
    [c.SELECTED_COMPANY]: null,
    [c.IS_LOADING]: false,
};